(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function getMainQtyInput(sectionId) {
    return (
      document.getElementById('Quantity-' + sectionId + '-Injected') ||
      document.getElementById('Quantity-' + sectionId) ||
      document.querySelector('product-info[data-section="' + sectionId + '"] input[name="quantity"]')
    );
  }

  function getStickyQtyInput(sectionId) {
    var bar = document.querySelector('[data-bm7-sticky-atc][data-section-id="' + sectionId + '"]');
    return bar ? bar.querySelector('[data-sticky-qty-input]') : null;
  }

  function syncQtyBeforeSubmit(sectionId) {
    var mainQty = getMainQtyInput(sectionId);
    var stickyQty = getStickyQtyInput(sectionId);
    var buyNowQty = document.getElementById('Quantity-' + sectionId + '-BuyNow');
    if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    if (mainQty && buyNowQty && !stickyQty) mainQty.value = buyNowQty.value;
    if (mainQty && stickyQty && buyNowQty) buyNowQty.value = stickyQty.value;
  }

  function getProductRoot(sectionId) {
    return (
      document.getElementById('MainProduct-' + sectionId) ||
      document.getElementById('ProductInfo-' + sectionId)?.closest('product-info') ||
      document.querySelector('product-info[data-section="' + sectionId + '"]')
    );
  }

  function getMainSubmit(root) {
    if (!root) return null;
    var sectionId = root.dataset.section;
    return (
      root.querySelector('#ProductSubmitButton-' + sectionId) ||
      root.querySelector('#bm7-submit-' + sectionId) ||
      root.querySelector('product-form [name="add"]')
    );
  }

  function getPriceNode(root, sectionId) {
    return (
      document.getElementById('price-' + sectionId) ||
      root.querySelector('#bm7-price-' + sectionId) ||
      root.querySelector('.pdp__price') ||
      root.querySelector('.price')
    );
  }

  function getPriceText(priceNode) {
    if (!priceNode) return '';
    var innerPrice = priceNode.querySelector('.price') || priceNode;
    if (innerPrice.classList.contains('price--on-sale')) {
      var sale = innerPrice.querySelector('.price-item--sale');
      if (sale) return (sale.textContent || '').replace(/\s+/g, ' ').trim();
    }
    var regular = innerPrice.querySelector('.price__regular > .price-item--regular');
    if (regular) return (regular.textContent || '').replace(/\s+/g, ' ').trim();
    var fallback = innerPrice.querySelector('.price-item--sale, .price-item--last, .price-item--regular');
    var node = fallback || innerPrice;
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function getSubmitLabel(mainSubmit) {
    if (!mainSubmit) return '';
    var mainText = mainSubmit.querySelector('span');
    var labelText = (mainText ? mainText.textContent : mainSubmit.textContent).trim();
    if (labelText.indexOf('—') !== -1) {
      labelText = labelText.split('—')[0].trim();
    }
    if (labelText.indexOf('-') !== -1 && labelText.toLowerCase().indexOf('add') === 0) {
      labelText = labelText.split('-')[0].trim();
    }
    return labelText;
  }

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function updateDockHeight(bar) {
    if (!bar || !bar.classList.contains('is-mounted') || !isMobile()) return;
    var h = bar.offsetHeight || 118;
    document.documentElement.style.setProperty('--bm7-dock-h', h + 'px');
  }

  /* ---- Visibility-reveal: the dock is a duplicate of the in-page Add-to-cart.
     It only appears once the in-page buttons scroll OFF the top of the viewport,
     so there's never a duplicate while they're still on screen. The chat
     launchers ride along via the .bm7-dock-visible class (see the CSS). ---- */
  var scrollTicking = false;

  function anyDockMounted() {
    return !!document.querySelector('.bm7-sticky-atc.is-mounted');
  }

  function setDockVisible(visible) {
    document.documentElement.classList.toggle('bm7-dock-visible', visible);
  }

  function getFooterEl() {
    if (getFooterEl.el && document.body.contains(getFooterEl.el)) return getFooterEl.el;
    getFooterEl.el =
      document.querySelector('[id*="bm7_footer"]') ||
      document.querySelector('.footer') ||
      document.querySelector('footer');
    return getFooterEl.el;
  }

  // Once the footer scrolls into view we're past the product, so the dock
  // should get out of the way instead of covering the footer links.
  function footerInView() {
    var f = getFooterEl();
    if (!f) return false;
    return f.getBoundingClientRect().top <= window.innerHeight - 40;
  }

  // The in-page Add-to-cart button is our anchor. While any part of it is in
  // view, the dock stays hidden (no duplication). Once it's scrolled above the
  // top of the viewport, reveal the dock.
  function getAnchorEl() {
    return document.querySelector('.product-form__buttons .product-form__submit');
  }

  function anchorScrolledPast() {
    var anchor = getAnchorEl();
    if (!anchor) return false;
    var rect = anchor.getBoundingClientRect();
    return rect.bottom <= 8;
  }

  function recomputeDockReveal() {
    scrollTicking = false;
    if (!isMobile() || !anyDockMounted()) {
      setDockVisible(false);
      return;
    }
    // Barely scrollable page: the in-page ATC never leaves view, so keep the
    // dock hidden — the button itself is always reachable.
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (maxScroll < 120) {
      setDockVisible(false);
      return;
    }
    if (footerInView()) {
      setDockVisible(false);
      return;
    }
    setDockVisible(anchorScrolledPast());
  }

  function onScrollReveal() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(recomputeDockReveal);
  }

  function initScrollReveal() {
    if (initScrollReveal.done) return;
    initScrollReveal.done = true;
    window.addEventListener('scroll', onScrollReveal, { passive: true });
    window.addEventListener('resize', onScrollReveal);
  }

  function syncStickyBar(bar) {
    var sectionId = bar.dataset.sectionId;
    var root = getProductRoot(sectionId);
    var mainSubmit = getMainSubmit(root);
    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
    var stickyLabel = bar.querySelector('[data-sticky-atc-label]');
    var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    var stickySpinner = bar.querySelector('[data-sticky-atc-spinner]');

    if (!stickyBtn || !mainSubmit) return;

    stickyBtn.disabled = mainSubmit.disabled;
    if (mainSubmit.getAttribute('aria-disabled') === 'true') {
      stickyBtn.setAttribute('aria-disabled', 'true');
    } else {
      stickyBtn.removeAttribute('aria-disabled');
    }

    var labelText = getSubmitLabel(mainSubmit);
    if (labelText && stickyLabel) stickyLabel.textContent = labelText;

    var priceText = getPriceText(getPriceNode(root, sectionId));
    if (priceText && stickyPrice) stickyPrice.textContent = priceText;

    var loading = mainSubmit.classList.contains('loading');
    stickyBtn.classList.toggle('loading', loading);
    if (stickySpinner) stickySpinner.classList.toggle('hidden', !loading);

    requestAnimationFrame(function () {
      updateDockHeight(bar);
    });
  }

  function mountDock(bar) {
    if (!isMobile()) {
      unmountDock(bar);
      return;
    }
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }
    bar.hidden = false;
    bar.classList.add('is-mounted');
    document.documentElement.classList.add('bm7-dock-mobile-active');
    updateDockHeight(bar);
    initScrollReveal();
    recomputeDockReveal();
  }

  function unmountDock(bar) {
    bar.classList.remove('is-mounted');
    bar.hidden = true;
    document.documentElement.classList.remove('bm7-dock-mobile-active');
    document.documentElement.classList.remove('bm7-dock-has-buy-now');
    document.documentElement.classList.remove('bm7-dock-visible');
    document.documentElement.style.removeProperty('--bm7-dock-h');
  }

  function applyViewportMode(bar) {
    if (isMobile()) {
      mountDock(bar);
      syncStickyBar(bar);
    } else {
      unmountDock(bar);
    }
  }

  function initStickyBar(bar) {
    if (!bar || bar.dataset.stickyReady) return;

    var sectionId = bar.dataset.sectionId;
    var root = getProductRoot(sectionId);
    var mainSubmit = getMainSubmit(root);
    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');

    if (!root || !mainSubmit || !stickyBtn) {
      bar.hidden = true;
      return;
    }

    bar.dataset.stickyReady = '1';

    stickyBtn.addEventListener('click', function () {
      if (mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true') return;
      syncQtyBeforeSubmit(sectionId);
      mainSubmit.click();
    });

    applyViewportMode(bar);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event?.data?.sectionId === sectionId) {
          requestAnimationFrame(function () {
            syncStickyBar(bar);
          });
        }
      });
    }

    document.addEventListener('bm7:product-updated', function () {
      syncStickyBar(bar);
    });

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', function () {
        applyViewportMode(bar);
      });
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(function () {
        applyViewportMode(bar);
      });
    }

    window.addEventListener('resize', function () {
      applyViewportMode(bar);
    });

    var observer = new MutationObserver(function () {
      syncStickyBar(bar);
    });

    observer.observe(mainSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      subtree: true,
      characterData: true,
      childList: true,
    });

    var priceNode = getPriceNode(root, sectionId);
    if (priceNode) {
      observer.observe(priceNode, {
        subtree: true,
        characterData: true,
        childList: true,
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bm7-sticky-atc]').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.bm7SyncStickyAtc = function (sectionId) {
    document.querySelectorAll('[data-bm7-sticky-atc]').forEach(function (bar) {
      if (!sectionId || bar.dataset.sectionId === String(sectionId)) syncStickyBar(bar);
    });
  };
})();
